import styles from "./CustomerInfo.module.css";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Button } from "@wwg/ui";
import { ContactView } from "shared/components/ContactView/ContactView";
import { contactPropType } from "shared/propTypes";
import { hasBitwise } from "shared/utils/hasBitwise";
import { CONTACT_TYPE } from "shared/enums";
import { Info } from "./sections/Info/Info";
import { SampleTracking } from "./sections/SampleTracking/SampleTracking";
import { SentBundles } from "./sections/SentBundles/SentBundles";
import { SurveyResults } from "./sections/SurveyResults/SurveyResults";

export function CustomerInfo({ contact, onEditClicked, onUnarchiveClicked }) {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.details}>
        <ContactView contact={contact} />
        <div className={styles.controls}>
          {hasBitwise(CONTACT_TYPE.Archived, contact.type) ? (
            <Button buttonStyle="hollowBronze" onClick={onUnarchiveClicked}>
              {t("buttons.unarchive")}
            </Button>
          ) : (
            <Button buttonStyle="hollow" onClick={onEditClicked}>
              {t("buttons.edit")}
            </Button>
          )}
        </div>
      </div>
      <div className={styles.sections}>
        <Info contact={contact} />
        {/* <SurveyResults contact={contact} /> */}
        <SampleTracking contact={contact} />
        {/* <SentBundles contact={contact} /> */}
      </div>
    </div>
  );
}

CustomerInfo.propTypes = {
  contact: contactPropType.isRequired,
};
